import * as React from 'react';

const SMARTSUPP_KEY = '31b92bcfc7d154465cfbac2499f8f7a3d2b9567e';

let injected = false;

const injectSmartsupp = () => {
  if (injected || typeof document === 'undefined') {
    return;
  }
  injected = true;

  const w = window as any;
  w._smartsupp = w._smartsupp || {};
  w._smartsupp.key = SMARTSUPP_KEY;
  if (w.smartsupp) {
    return;
  }
  const queue: any = function () {
    queue._.push(arguments);
  };
  queue._ = [];
  w.smartsupp = queue;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.charset = 'utf-8';
  script.async = true;
  script.src = 'https://www.smartsuppchat.com/loader.js?';
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }
};

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart'];

const FALLBACK_DELAY_MS = 3000;

const SmartsuppChat = () => {
  React.useEffect(() => {
    if (injected) {
      return undefined;
    }

    let timeoutId: any;

    const start = () => {
      INTERACTION_EVENTS.forEach((e) => window.removeEventListener(e, start));
      clearTimeout(timeoutId);
      injectSmartsupp();
    };

    INTERACTION_EVENTS.forEach((e) =>
      window.addEventListener(e, start, { once: true, passive: true }),
    );
    timeoutId = setTimeout(start, FALLBACK_DELAY_MS);

    return () => {
      INTERACTION_EVENTS.forEach((e) => window.removeEventListener(e, start));
      clearTimeout(timeoutId);
    };
  }, []);

  return null;
};

export default SmartsuppChat;
